import React from 'react';
import { Sparkles, Check } from 'lucide-react';
import { FadeIn } from './FadeIn';
const features = ['Qué escribir en cada etapa de la conversación', 'Cómo responder para generar interés real', 'Cómo reactivar chats muertos', 'Cómo hacer que él invierta emocionalmente', 'Cómo evitar errores que matan la atracción', 'La psicología oculta de los hombres que SÍ responden'];
export function ProductReveal() {
  return <section className="py-14 px-6 bg-[#161616] relative" data-id="element-291">
      <div className="max-w-5xl mx-auto" data-id="element-292">
        <FadeIn data-id="element-293">
          <div className="text-center mb-10" data-id="element-294">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-rose/10 text-brand-rose text-sm font-medium mb-4" data-id="element-295">
              <Sparkles className="w-4 h-4" data-id="element-296" />
              Presentando el Sistema
            </span>
            <h2 className="font-serif text-4xl md:text-6xl font-bold mb-4" data-id="element-297">
              Nunca Más Te Dejan <br data-id="element-298" />
              <span className="text-brand-rose italic" data-id="element-299">en Visto</span>
            </h2>
            <p className="text-xl text-brand-lightGray max-w-2xl mx-auto" data-id="element-300">
              Un sistema psicológico paso a paso que te enseña exactamente cómo
              comunicarte para volverte magnética.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-301">
          <FadeIn direction="left" data-id="element-302">
            <div className="relative flex justify-center" data-id="element-303">
              <div className="absolute inset-0 bg-brand-rose/15 rounded-full blur-[80px] scale-75 pointer-events-none" data-id="element-304" />
              <img src="https://cdn.magicpatterns.com/uploads/sL1pDaDyzYLntnvcP3mhMv/Nunca_mas_te_dejan_en_visto.png" alt="Nunca Más Te Dejan en Visto — Guía práctica de mensajes" className="relative z-10 w-full max-w-sm rounded-2xl shadow-2xl shadow-brand-rose/20 border border-white/10" data-id="element-305" />
            </div>
          </FadeIn>

          <FadeIn direction="right" data-id="element-306">
            <div className="space-y-6" data-id="element-307">
              <h3 className="text-2xl font-semibold mb-4" data-id="element-308">
                Lo que vas a descubrir:
              </h3>
              <div className="space-y-3" data-id="element-309">
                {features.map((feature, index) => <div key={index} className="flex items-start gap-3 p-3 rounded-xl bg-white/5 border border-white/5 hover:bg-white/10 transition-colors" data-id="element-310">
                    <div className="w-6 h-6 rounded-full bg-brand-rose/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-311">
                      <Check className="w-4 h-4 text-brand-rose" data-id="element-312" />
                    </div>
                    <p className="text-brand-cream text-sm" data-id="element-313">{feature}</p>
                  </div>)}
              </div>
              <p className="text-brand-lightGray italic border-l-2 border-brand-rose pl-4 text-sm" data-id="element-314">
                No es teoría. Es una guía práctica, directa y aplicable desde el
                primer día.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}